module.exports = __webpack_public_path__ + "img/renyuanguanlianshenhe_1.afc3341a.png";